import React, { Component} from 'react';


// import Icon from '../UI/Icons/index';
import Aux from '../../hoc/Aux/Aux';
import Calendar from '../Calendar/Calendar';
import MobileCalendar from '../MobileCalendar/MobileCalendar';
import './DatePicker.css';


class DatePicker extends Component {

  render() {
    return (
      <Aux>
        <MobileCalendar maxBookingDaysInAdvance={this.props.maxBookingDaysInAdvance} />
        <Calendar maxBookingDaysInAdvance={this.props.maxBookingDaysInAdvance} />
      </Aux>
    );
  }
}

export default DatePicker;


// WEBPACK FOOTER //
// ./src/components/DatePicker/DatePicker.js